import { cStrike } from "../../classes/strike";
import { tMaturityDate } from "../../interfaces/interfaces";

export enum eBasicActionTypes {
	SET_CURRENT_STEP = 'BASIC/SET_CURRENT_STEP',
	SET_CURRENT_F_TOKEN = 'BASIC/SET_CURRENT_F_TOKEN',
	SET_CURRENT_U_TOKEN = 'BASIC/SET_CURRENT_U_TOKEN',
	SET_CURRENT_DIRECTION = 'BASIC/SET_CURRENT_DIRECTION',
	SET_CURRENT_MATURITY_DATE = 'BASIC/SET_CURRENT_MATURITY_DATE',
	SET_CURRENT_STRIKE = 'BASIC/SET_CURRENT_STRIKE',
	STEP_BACK = 'BASIC/STEP_BACK',
}

export type tBasicAction =
	iSetCurrentStepAction |
	iSetCurrentFTokenAction |
	iSetCurrentUTokenAction |
	iSetCurrentDirectionAction |
	iSetCurrentMaturityDateAction |
	iSetCurrentStrikeAction |
	iStepBackAction
;

interface iSetCurrentStepAction {
	type: eBasicActionTypes.SET_CURRENT_STEP,
	payload: 0 | 1 | 2 | 3 | 4
}

interface iSetCurrentFTokenAction {
	type: eBasicActionTypes.SET_CURRENT_F_TOKEN,
	payload: string
}

interface iSetCurrentUTokenAction {
	type: eBasicActionTypes.SET_CURRENT_U_TOKEN,
	payload: string
}

interface iSetCurrentDirectionAction {
	type: eBasicActionTypes.SET_CURRENT_DIRECTION,
	payload: 'up' | 'down'
}

interface iSetCurrentMaturityDateAction {
	type: eBasicActionTypes.SET_CURRENT_MATURITY_DATE,
	payload: tMaturityDate
}

interface iSetCurrentStrikeAction {
	type: eBasicActionTypes.SET_CURRENT_STRIKE,
	payload: cStrike
}

interface iStepBackAction {
	type: eBasicActionTypes.STEP_BACK
}